import { useState } from "react";
import Sidebar from "./Sidebar";

## Basic Usage

export function BasicSidebar() {
  const [open, setOpen] = useState(true);
  return (
    <div style={{ position: "relative", height: "300px", border: "1px dashed #ccc", overflow: "hidden" }}>
      <Sidebar open={open} toggleOpen={setOpen} align="left">
        <div style={{ padding: "1rem", width: "200px", background: "#f5f5f5", height: "100%" }}>
          <h4 style={{ margin: "0 0 1rem" }}>Sidebar</h4>
          <nav style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <a href="#" style={{ textDecoration: "none", color: "#3b82f6" }}>
              Dashboard
            </a>
            <a href="#" style={{ textDecoration: "none", color: "#666" }}>
              Projects
            </a>
            <a href="#" style={{ textDecoration: "none", color: "#666" }}>
              Settings
            </a>
          </nav>
        </div>
      </Sidebar>
      <div style={{ marginLeft: open ? "200px" : "0", padding: "1rem", transition: "margin 0.3s" }}>
        <button onClick={() => setOpen(!open)}>Toggle Sidebar</button>
        <p>Main content area</p>
      </div>
    </div>
  );
}

<BasicSidebar />

---

## Right Alignment

export function RightSidebar() {
  const [open, setOpen] = useState(true);
  const [locked, setLocked] = useState(true);
  return (
    <div
      style={{ position: "relative", height: "250px", border: "1px dashed #ccc", overflow: "hidden", display: "flex" }}
    >
      <div style={{ flex: 1, padding: "1rem" }}>
        <button onClick={() => setLocked(!locked)}>{locked ? "Unlock" : "Lock"} Sidebar</button>
        <p>Content with right sidebar</p>
        <p style={{ fontSize: "14px", color: "#666" }}>
          {locked ? "Sidebar is locked in place" : "Sidebar overlays content"}
        </p>
      </div>
      <Sidebar open={open} toggleOpen={setOpen} align="right" lockedOpen={locked}>
        <div style={{ padding: "1rem", width: "180px", background: "#fafafa", height: "100%" }}>
          <h4 style={{ margin: "0 0 0.5rem" }}>Details</h4>
          <p style={{ fontSize: "14px", color: "#666" }}>Right-aligned sidebar for details panel.</p>
        </div>
      </Sidebar>
    </div>
  );
}

<RightSidebar />

---

## Hover to Open

export function HoverSidebar() {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: "relative", height: "250px", border: "1px dashed #ccc", overflow: "hidden" }}>
      <Sidebar open={open} toggleOpen={setOpen} align="left" openOnHover>
        <div style={{ padding: "1rem", width: "200px", background: "#f5f5f5", height: "100%" }}>
          <h4 style={{ margin: "0 0 1rem" }}>Hover Menu</h4>
          <p style={{ fontSize: "14px", color: "#666" }}>Hover near the left edge to open this sidebar.</p>
        </div>
      </Sidebar>
      <div style={{ padding: "1rem" }}>
        <p>Hover near the left edge to reveal the sidebar.</p>
        <p style={{ color: "#666", fontSize: "14px" }}>Current state: {open ? "Open" : "Closed"}</p>
      </div>
    </div>
  );
}

<HoverSidebar />

---

## Locked Open

export function LockedSidebar() {
  const [open, setOpen] = useState(true);
  const [locked, setLocked] = useState(true);
  return (
    <div style={{ position: "relative", height: "250px", border: "1px dashed #ccc", overflow: "hidden" }}>
      <Sidebar open={open} toggleOpen={setOpen} align="left" lockedOpen={locked}>
        <div style={{ padding: "1rem", width: "200px", background: "#fafafa", height: "100%" }}>
          <h4 style={{ margin: "0 0 0.5rem" }}>Navigation</h4>
          <p style={{ fontSize: "14px", color: "#666" }}>
            {locked ? "Sidebar is locked open" : "Sidebar can be closed"}
          </p>
        </div>
      </Sidebar>
      <div style={{ marginLeft: "200px", padding: "1rem" }}>
        <button onClick={() => setLocked(!locked)}>{locked ? "Unlock" : "Lock"} Sidebar</button>
        <p style={{ marginTop: "0.5rem" }}>When locked, the sidebar stays in place and doesn't overlay content.</p>
      </div>
    </div>
  );
}

<LockedSidebar />

---

## Navigation Example

export function NavigationSidebar() {
  const [open, setOpen] = useState(true);
  const [active, setActive] = useState("dashboard");
  const items = [
    { id: "dashboard", label: "Dashboard" },
    { id: "projects", label: "Projects" },
    { id: "team", label: "Team" },
    { id: "reports", label: "Reports" },
    { id: "settings", label: "Settings" },
  ];
  return (
    <div style={{ position: "relative", height: "300px", border: "1px dashed #ccc", overflow: "hidden" }}>
      <Sidebar open={open} toggleOpen={setOpen} align="left" lockedOpen>
        <div style={{ width: "180px", padding: "1rem 0", background: "#1a1a2e", height: "100%", color: "white" }}>
          <div style={{ padding: "0 1rem 1rem", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
            <span style={{ fontWeight: 600 }}>MyApp</span>
          </div>
          <nav style={{ padding: "0.5rem 0" }}>
            {items.map((item) => (
              <div
                key={item.id}
                onClick={() => setActive(item.id)}
                style={{
                  padding: "0.5rem 1rem",
                  cursor: "pointer",
                  background: active === item.id ? "rgba(255,255,255,0.1)" : "transparent",
                  borderLeft: active === item.id ? "3px solid #3b82f6" : "3px solid transparent",
                }}
              >
                {item.label}
              </div>
            ))}
          </nav>
        </div>
      </Sidebar>
      <div style={{ marginLeft: "180px", padding: "1rem" }}>
        <h3 style={{ margin: "0 0 0.5rem" }}>{items.find((i) => i.id === active)?.label}</h3>
        <p style={{ color: "#666" }}>Content for {active} page.</p>
      </div>
    </div>
  );
}

<NavigationSidebar />
